import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../../../../lib/utilities';

export const Label = ({ name, label, onClick, lightLabel }) => (
    <span className={(lightLabel ? '' : name) + '__label'} onClick={onClick}>
        {label}
    </span>
);

Label.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]).isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

Label.defaultProps = {
    onClick: noop,
};
